<template>
    <div id="app" class="app fond">
        <div class="DivImageHautPage">
            <img :src="Page.image" class="imageHautPage" :alt="'Image'+Page.page">
        </div>

        <div class="fond-page">
            <section class="corps-texte">
                <section class="en-tete-page">
                    <h1>{{Page.page}}</h1>
                    <p class="paragraphe-en-tete" v-if="Page.description != ''" v-html="Page.description"></p>
                </section>
                <h3>Conseil municipal</h3>
                <section class="Section-pages section-pages-cartes">
                    <template v-for="elu in Elus">
                        <div v-if="elu.fin_de_mandat == ''" :key="elu.id" class="carteconseillerliste" style="position: relative;">
                            <div @click="infoConseiller = ! infoConseiller">
                                <img :src="elu.image" class="portrait-conseiller" :alt="elu.nom">
                            </div>
                            <div  v-for="role in elu.roles" :key="role.term_id">
                                <img v-if="role.name == 'Maire'" src="static/css/img/BanderoleMaire.png" alt="" style="border-radius:0; box-shadow: none; position: absolute; top:0; left: 0;">
                            </div>

                            <section class="contenu-carte">
                                <h5>{{elu.prenom}} {{elu.nom}}</h5>
                                <i v-for="role in elu.roles" :key="role.term_id">{{role.name}} <br> </i>
                                <p class="carte-hover" v-if="elu.description != null">{{elu.description}}</p>
                                <p class="carte-non-hover" v-if="elu.description != null" v-show="infoConseiller">{{elu.description}}</p>
                            </section>
                        </div>
                    </template>
                </section>

                <h3>Employés municipaux</h3>
                <section class="Section-pages section-pages-cartes">
                    <div v-for="employe in Employes" :key="employe.id">
                        <div v-if="employe.fin_de_mandat == ''" class="carteconseillerliste">
                            <div @click="infoConseiller = ! infoConseiller">
                                <img :src="employe.image" class="portrait-conseiller" :alt="employe.nom">
                            </div>

                            <section class="contenu-carte" @click="infoConseiller = ! infoConseiller">
                                <h5>{{employe.prenom}} {{employe.nom}}</h5>
                                <i v-for="role in employe.roles" :key="role.term_id">{{role.name}} <br> </i>
                                <p class="carte-hover" v-if="employe.description != null">{{employe.description}}</p>
                                <p class="carte-non-hover" v-if="employe.description != null" v-show="infoConseiller">{{employe.description}}</p>
                            </section>
                        </div>
                    </div>
                </section>
                <h3>Administrateur</h3>
                <section class="Section-pages section-pages-cartes">
                    <div v-for="admin in Administrateur" :key="admin.id">
                        <div v-if="admin.fin_de_mandat == ''" class="carteconseillerliste">
                            <div @click="infoConseiller = ! infoConseiller">
                                <img :src="admin.image" class="portrait-conseiller" :alt="admin.nom">
                            </div>

                            <section class="contenu-carte" @click="infoConseiller = ! infoConseiller">
                                <h5>{{admin.prenom}} {{admin.nom}}</h5>
                                <i v-for="role in admin.roles" :key="role.term_id">{{role.name}} <br> </i>
                                <p class="carte-hover" v-if="admin.description != null">{{admin.description}}</p>
                                <p class="carte-non-hover" v-if="admin.description != null" v-show="infoConseiller">{{admin.description}}</p>
                                <h5>Contact : <a style="color: #FFFFFF" :href="'mailto:'+admin.email">{{admin.email}}</a></h5>
                            </section>
                        </div>
                    </div>
                </section>
            </section>
        </div>
    </div>
</template>

<script>
import param from '@/param/param'

export default {
    name: 'EquipeMunicipale',
    data () {
        return{
            Mairie:{
                id:0,
                acf:{
                    telephone: 0,
                    email: null,
                    adresse: null,
                    complement_adresse: null,
                    lien_adresse: null,
                    horaires:{},
                    image: {
                        id:0,
                        url:null
                    },
                    visuels: {},
                    logo:{},
                    description_dae: null,
                    image_dae:{},
                    visuels_dae:{}
                }
            },
            Page: {
                page: 'Erreur chargement',
                image: 'https://mairie-quenne.fr/wp-content/uploads/2022/05/Accueil.jpg',
                description: ''
            },
            msgImportant:{
                id:0,
                acf: {
                    message:null
                }
            },
            motMaire:{
                id:0,
                acf:{
                    paragraphe:null,
                    maire: 0
                }
            },
            Elus:{
                adresse: null,
                debut_de_mandat: null,
                description: null,
                email: null,
                fin_de_mandat: null,
                genre: null,
                id: 0,
                image: null,
                nom: null,
                prenom: null,
                roles: {},
                telephone: null,

            },
            Employes:{
                adresse: null,
                debut_de_mandat: null,
                description: null,
                email: null,
                fin_de_mandat: null,
                genre: null,
                id: 0,
                image: null,
                nom: null,
                prenom: null,
                roles: {},
                telephone: null,
            },
            Employes:{
                adresse: null,
                debut_de_mandat: null,
                description: null,
                email: null,
                fin_de_mandat: null,
                genre: null,
                id: 0,
                image: null,
                nom: null,
                prenom: null,
                roles: {},
                telephone: null,
            },
            ladate: null,
            date: null,
            infoConseiller: false,

        }
    }, 

    created(){
        axios.get(param.hostacf+'Mairie')
        .then(response =>{
        this.Mairie = response.data;
            console.log('Mairie', this.Mairie)
        })
        .catch(error => console.log(error))
        
        axios.get(param.hostacf+'message_important')
        .then(response =>{
        this.msgImportant = response.data;
            console.log('Msg', this.msgImportant)
        })
        .catch(error => console.log(error))

        axios.get(param.hostacf+'mot_du_maire')
        .then(response =>{
        this.motMaire = response.data;
            console.log('Mot du maire', this.motMaire)
        })
        .catch(error => console.log(error))

        axios.get(param.host+'elu/v1/listeElus')
        .then(response =>{
            this.listeElus = response.data;
            this.Elus = new Array;
            this.Employes = new Array;
            this.Administrateur = new Array;
            var j = 0;
            var k = 0;
            var l = 0;
            
            console.log('listeElus', this.listeElus)
            this.listeElus.forEach((element, i) => {
                console.log('element', element, element.categorie)
                if(element.categorie === 'Élu'){
                    this.Elus[j] = this.listeElus[i];
                    j++;
                }else if(element.categorie === 'Administrateur'){
                    this.Administrateur[l] = this.listeElus[i];
                    l++;
                }else if(element.categorie === 'Employé'){
                    this.Employes[k] = this.listeElus[i];
                    k++;
                }
                console.log('Elus', this.Elus)
            })
        })
        .catch(error => console.log(error))

        axios.get(param.host+'page/v1/listePages')
        .then(response =>{
            this.listePages = response.data;
            console.log(this.listePages)
            this.Page = {
                page: 'Erreur chargement',
                image: param.hostContent+'uploads/2022/05/Accueil.jpg',
                description: ''
            }
            for(var i = 0; this.listePages.length > i; i++){
                if(this.listePages[i].page == 'Équipe municipale'){
                    console.log(this.listePages[i])
                    return this.Page = this.listePages[i]
                }
            }
        })
        .catch(error => console.log(error))
    }
}
</script>

<style scoped>

</style>




// WEBPACK FOOTER //
// src/components/Equipe-municipale.vue